import { roleFinder } from "helpers/roleFinder";
import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  IS_ADMIN,
} from "./actionTypes";

const initialState = {
  error: "",
  isAdmin: false,
  loading: false,
  role: JSON.parse(localStorage.getItem("authuser"))?.role,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case IS_ADMIN:
      state = {
        ...state,
        isAdmin: action.payload,
      };
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      return {
        ...state,
        items: "true",
        ...action.payload,
        role: roleFinder(action.payload.usertype),
        loading: false,
      };
      break;
    case LOGOUT_USER:
      state = { ...state };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
